import React from 'react';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';
import { connect } from 'react-redux';
import { css } from 'emotion';
import SecurityService from 'services/SecurityService';
import { Checkbox } from 'antd';

import HitResult from './components/HitResult';
import CustomSortingSelector from './components/CustomSortingSelector';
import {
    SearchkitProvider,
    SearchBox,
    InitialLoader,
    Hits,
    NoHits,
    HitsStats,
    SelectedFilters,
    RefinementListFilter,
    ResetFilters,
    Pagination,
    SearchkitManager
} from 'searchkit';

import './styles.less';
import 'searchkit/release/theme.css';
import { colorTextBlack, colorRed } from 'styles/base.js';

const baseUrl = process.env.REACT_APP_BASE_URL;
let searchkitManager = null;

const searchContainer = css`
    width: 100%;
    height: calc(100vh - 45px);
    overflow-y: auto;
    .search-kit-container {
        padding: 20px;
        display: grid;
        width: 960px;
        margin: 0 auto;
        grid-template-rows: [Row1] auto [Row2] 1fr;
        grid-template-columns: [Col1] auto [Col2] 1fr;
        background-color: #f4f4f4;
    }
    .search-box-container {
        grid-column: Col1 / span 3;
        grid-row: Row1;
        display: flex;
        position: relative;
        background-color: #194173;
        padding: 10px 15px;
        box-shadow: 0 0 4px rgba(0,0,0,.14), 0 4px 8px rgba(0,0,0,.28);
        .sk-search-box {
            height: 42px;
            flex: 1;
            > form {
                width: 100%;
                display: flex;
                background-color: white;
                border-radius: 3px 0 0 3px;
                .sk-search-box__icon {
                    margin: 10px 10px 0 10px;
                    &:before {
                        opacity: 0.65;
                        height: 24px;
                        width: 24px;
                    }
                }
                .sk-search-box__text {
                    flex: 1;
                    height: 20px;
                    border: 0 !important;
                    font-size: 14px;
                    padding: 11px 20px;
                    color: ${colorTextBlack};
                }
                .sk-spinning-loader {
                    border-left: 3px solid #194173;
                }
                .sk-search-box__action {
                    display: none;
                }
            }
        }
        .include-search {
            display: flex;
            position: absolute;
            font-size: 12px;
            top: 22px;
            right: 60px;
            input {
                margin: 0px 2px 0 15px;
            }
        }
    }
    .filter-panel {
        grid-column: Col1;
        grid-row: Row2;
        flex: 1;
        padding: 20px;
        background: white;
        margin: 15px;
        box-shadow: 0 0 4px rgba(0,0,0,.05);
        .filter-container {
            flex: 1;
            margin-bottom: 20px;
            font-size: 17px;
        }
        .sk-input-filter {
            color: ${colorTextBlack};
        }
        .filter--language, .filter--group, .filter--project, .filter--author {
            width: 208px;
            .sk-panel__content {
                font-size: 13px;
                .sk-item-list {
                    cursor: pointer;
                    padding-right: 6px;
                    .sk-item-list-option {
                        display: flex;
                        height: 24px;
                    }
                    .sk-item-list-option__text {
                        flex: 1;
                        margin-left: 6px;
                        white-space: nowrap;
                        overflow-x: hidden;
                        text-overflow: ellipsis;
                    }
                    .sk-item-list-option__count {
                        display: inline-block;
                        color: #08c;
                    }
                }
                .sk-refinement-list__view-more-action {
                    cursor: pointer;
                }
            }
        }
        .sk-search-box {
            height: 28px;
            > form {
                background-color: white;
                border-radius: 3px 0 0 3px;
                border: 1px solid #DCDCDC;
                .sk-search-box__icon {
                    margin: 3px 2px 0 6px;
                    &:before {
                        opacity: 0.65;
                        height: 20px;
                        width: 20px;
                    }
                }
                .sk-search-box__text {
                    border: 0 !important;
                    font-size: 12px;
                    padding-left: 0;
                    color: ${colorTextBlack};
                }
                .sk-spinning-loader {
                    display: none;
                }
                .sk-search-box__action {
                    display: none;
                }
            }
        }
    }
    .hits-container {
        grid-column: Col2;
        grid-row: Row2;
        flex: 1;
        margin: 15px 15px 15px 0;
        padding: 20px;
        overflow-y: auto;
        background-color: white;
        box-shadow: 0 0 4px rgba(0,0,0,.05);
        .hits-header {
            display: flex;
            .sk-hits-stats__info {
                margin: 5px;
            }
            .sort-by {
                margin: 5px;
                font-size: 14px;
            }
            .sk-select {
                select {
                    font-weight: 500;
                    font-size: 13px;
                }
            }
        }
        .hits-sub-header {
            .sk-selected-filters {
                display: flex;
                flex-flow: row wrap;
                .sk-selected-filters-option {
                    display: flex;
                    flex: 0 0 auto;
                    background: #e8e8e8;
                    border: none;
                    font-size: 14px;
                    line-height: 20px;
                    border-radius: 3px;
                    color: #08c;
                    padding: 2px 4px;
                    margin: 2px 4px 2px 0;
                }
                .sk-selected-filters-option__remove-action {
                    flex: auto;
                    cursor: pointer;
                    font-size: 16px;
                    line-height: 18px;
                    font-weight: 700;
                    border-left: 1px solid #ddd;
                    padding: 0 10px 0 10px;
                    margin-left: 10px;
                }
            }
            .reset-expand-all-container {
                display: inline-flex;
                width: 100%;
            }
            .sk-reset-filters {
                width: 82px;
                font-size: 12px;
                color: #adadad;
                cursor: pointer;
                &:hover {
                    color: #868686;
                }
            }
            .ant-checkbox-wrapper {
                flex: 1;
                text-align: right;
                padding-top: 9px;
            }
        }
        .loading-container {
            width: 100%;
            margin-top: 150px;
            .spinner-container {
                margin: 0 auto;
                width: 100px;
                color: #7d7d7d;
                font-size: 18px;
            }
        }
        .sk-pagination-navigation {
            margin-top: 18px;
        }
        .sk-toggle {
            display: flex;
            align-content: center;
            text-align: center;
            border-radius: 3px;
            max-height: 30px;
            .sk-toggle-option {
                flex: 1;
                background-color: #fff;
                border: 1px solid #ccc;
                cursor: pointer;
                font-size: 13px;
                padding: 5px 10px;
                border-right: none;
                white-space: nowrap;
                &:first-child {
                    flex: 4;
                }
                &:last-child {
                    flex: 4;
                    border-right: 1px solid #ccc;
                }
                &.is-active {
                    cursor: default;
                    color: white;
                    background-color: #00BD70;
                }
                &:hover {
                    font-weight: 600;
                }
            }
        }
    }
`;

const hitsLoader = () => ((
    <div className="loading-container">
        <div className="spinner-container">
            <i className="fa fa-spinner fa-pulse"  aria-hidden="true"/>
            Loading..
        </div>
    </div>
));


class Search extends React.Component {
    static propTypes = {
        userLoggedIn: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = {
            searchFileName: true,
            searchContent: true,
            sortKey: 'relevance',
            isExpandAll: true,
            showExpandAll: false
        };
        this.onResultsChanged = this.onResultsChanged.bind(this);
    }

    componentWillMount() {
        const sessionId = localStorage.getItem('sessionId');
        searchkitManager = new SearchkitManager(`${baseUrl}/es/code`, {
            httpHeaders: (sessionId) ? { 'PCM-Session-ID': sessionId } : {}
        });
        searchkitManager.addResultsListener(this.onResultsChanged);
    }

    getResultItem = (props) => {
        return (
            <HitResult
                result={props.result}
                sortingStyle={this.sortingStyle}
                isExpandAll={this.state.isExpandAll}
            />
        );
    };

    onResultsChanged = (results) => {
        // Check if there is any text in searchbox, if not hide expand all
        if (!('q' in searchkitManager.state) || searchkitManager.state.q === '') {
            if (this.state.showExpandAll !== false) {
                this.setState({ showExpandAll: false });
            }
        } else {
            if (this.state.showExpandAll !== true) {
                this.setState({ showExpandAll: true });
            }
        }
    };

    mainQueryBuilder = (query) => {
        const { searchFileName, searchContent } = this.state;
        // Default queries
        let queries = [];
        // Search file name query
        if (searchFileName) {
            const queryLowerCase = query.toLowerCase();
            queries = queries.concat([
                { wildcard: { 'display_file_path.keyword': { value: queryLowerCase, boost: 15 } } },
                { wildcard: { file_path: { value: queryLowerCase, boost: 15 } } },
                { wildcard: { file_name: { value: queryLowerCase, boost: 15 } } },
                { wildcard: { group_name: { value: queryLowerCase, boost: 15 } } },
            ]);
        }
        // Search content queries
        if (searchContent) {
            queries.push(
                { match_phrase: { 'attachment.content': { query, analyzer: 'special_char_analyzer', boost: 5 } } }
            );
        }
        return this.buildQuery(queries);
    };

    projectQueryBuilder = (query) => (
        this.buildQuery([{ wildcard: { project_name: { value: query.toLowerCase(), boost: 15 } } }])
    );

    buildQuery = (queries) => ({
        function_score: {
            query: {
                bool: {
                    should: queries,
                    minimum_should_match: 1
                }
            },
            functions: [{
                filter: { terms: { group_name: ['vap', 'ingest'] } },
                weight: 100
            }],
            boost_mode: 'multiply'
        }
    });

    customHighlight = () => ({
        fields: {
            'attachment.content': {
                type: 'unified',
                fragment_size: 0,
                number_of_fragments: 100
            }
        }
    });

    searchFileNameOnChange = () => {
        this.setState(
            { searchFileName: !(this.state.searchFileName) },
            () => searchkitManager.reloadSearch()
        );
        searchkitManager.reloadSearch();
    };

    searchContentOnChange = () => {
        this.setState(
            { searchContent: !(this.state.searchContent) },
            () => searchkitManager.reloadSearch()
        );
    };

    sortOrderOnChange = (key) => {
        this.setState({ sortKey: key });
    };

    expandAllOnChange = (e) => {
        this.setState({ isExpandAll: e.target.checked });
    };

    renderSearch() {
        const { searchFileName, searchContent, sortKey, isExpandAll, showExpandAll } = this.state;

        // Set resultItem label bold depending on sort order
        this.sortingStyle = {
            groupStyle: null,
            projectStyle: null,
            pathStyle: null
        };
        switch (sortKey) {
            case 'group': this.sortingStyle.groupStyle = 'bold'; break;
            case 'project': this.sortingStyle.projectStyle = 'bold'; break;
            case 'file_name': this.sortingStyle.pathStyle = 'bold'; break;
            default: break;
        }

        // Expand all checkbox
        let expandAllJSX = null;
        if (showExpandAll) {
            expandAllJSX = (
                <Checkbox checked={isExpandAll} onChange={this.expandAllOnChange}>
                    Expand All
                </Checkbox>
            );
        }

        return (
            <React.Fragment>
                <div className={searchContainer}>
                    <SearchkitProvider searchkit={searchkitManager}>
                        <div className="search-kit-container">
                            <div className="search-box-container">
                                <SearchBox
                                    translations={{ 'searchbox.placeholder': 'Search file paths (supports wildcard * character) OR code' }}
                                    autofocus
                                    searchOnChange={false}
                                    queryBuilder={this.mainQueryBuilder}
                                />
                                <Flexbox className="include-search" flexDirection="row" alignItems="center">
                                    <input
                                        type="checkbox"
                                        className="sk-item-list-option__checkbox"
                                        checked={searchFileName}
                                        onChange={this.searchFileNameOnChange}
                                    />
                                    <div>search file path</div>
                                    <input
                                        type="checkbox"
                                        className="sk-item-list-option__checkbox"
                                        checked={searchContent}
                                        onChange={this.searchContentOnChange}
                                    />
                                    <div>search content</div>
                                </Flexbox>
                            </div>
                            <div className="filter-panel">
                                <div className="filter-container">
                                    <RefinementListFilter
                                        id="language"
                                        title="Language"
                                        field="language.keyword"
                                        operator="OR"
                                    />
                                </div>
                                <div className="filter-container">
                                    <RefinementListFilter
                                        id="group"
                                        title="Group"
                                        field="group_name.keyword"
                                        operator="OR"
                                    />
                                </div>
                                <div className="filter-container">
                                    <div className="sk-panel__header">Project</div>
                                    <SearchBox
                                        id="projectSearch"
                                        translations={{ 'searchbox.placeholder': 'Search project name' }}
                                        searchOnChange={false}
                                        queryFields={['project_name']}
                                        prefixQueryFields={['project_name']}
                                    />
                                    <RefinementListFilter
                                        id="project"
                                        title=""
                                        field="project_name.keyword"
                                        operator="OR"
                                    />
                                </div>
                                <div className="filter-container">
                                    <RefinementListFilter
                                        id="author"
                                        title="Author"
                                        field="contributors.keyword"
                                        operator="OR"
                                    />
                                </div>
                            </div>
                            <div className="hits-container">
                                <div className="hits-header">
                                    <HitsStats translations={{ 'hitstats.results_found': '{hitCount} files found' }}/>
                                    <div className="sort-by">Sort By:</div>
                                    <CustomSortingSelector onChange={this.sortOrderOnChange} sortKey={sortKey}
                                        options={[
                                            { label: 'Relevance', key: 'relevance', field: '_score', order: 'desc', defaultOption: true },
                                            { label: 'Group', key: 'group', fields: [
                                                { field: 'group_name.keyword', options: { order: 'asc' } },
                                                { field: '_score', options: { order: 'desc' } }
                                            ] },
                                            { label: 'Project', key: 'project', fields: [
                                                { field: 'project_name.keyword', options: { order: 'asc' } },
                                                { field: '_score', options: { order: 'desc' } }
                                            ] },
                                            { label: 'File Name', key: 'file_name', fields: [
                                                { field: 'file_name.keyword', options: { order: 'asc' } },
                                                { field: '_score', options: { order: 'desc' } }
                                            ] }
                                        ]}
                                    />
                                </div>
                                <div className="hits-sub-header">
                                    <SelectedFilters />
                                    <div className="reset-expand-all-container">
                                        <ResetFilters />
                                        {expandAllJSX}
                                    </div>
                                </div>
                                <Hits
                                    hitsPerPage={30}
                                    sourceFilter={ ['group_name', 'project_name', 'file_path', 'file_name', 'contributors'] }
                                    mod="sk-hits-list"
                                    // This needs to be arrow function to cause a change in the prop and force re-render
                                    // eslint-disable-next-line react/jsx-no-bind
                                    itemComponent={(props) => (this.getResultItem(props))}
                                    customHighlight={this.customHighlight()}
                                />
                                <NoHits
                                    translations={{
                                        'NoHits.NoResultsFound': 'No results found for \'{query}\'. Using the search box for file paths may require wildcard * characters.'
                                    }}
                                />
                                <InitialLoader component={hitsLoader} />
                                <Pagination
                                    showNumbers
                                    translations={{
                                        'pagination.previous': 'Previous Page',
                                        'pagination.next': 'Next Page' 
                                    }}
                                />
                            </div>
                        </div>
                    </SearchkitProvider>
                </div>
            </React.Fragment>
        );
    }

    render() {
        let component;
        if (this.props.userLoggedIn) {
            component = this.renderSearch();

        } else {
            const loginStyle = css`
                text-align: center;
                padding: 50px;
                color: ${colorRed};
                font-weight: 900;
            `;
            component =  (
                <div className={loginStyle}>You must be logged in in order to search the code catalog.</div>
            );
        }
        return component;
    }
}

// Automatically pull state information from the store and
// pass it to this component as props
const mapStateToProps = (storeState) => {
    // we need to know if the user is logged in, since only logged in users may search code
    const loginState = SecurityService.getMyState(storeState);
    const userLoggedIn = loginState.userLoggedIn;

    return {
        userLoggedIn
    };
};

export default connect(mapStateToProps)(Search);



// WEBPACK FOOTER //
// ./src/components/page/search/Search.js